import {gql} from '@apollo/client'

// Mutation string para crear recurso (usar con upload de archivos)
export const CREATE_RESOURCE_CENTER_STR = `
  mutation createResourceCenter($resourceData: resource_center_input!) {
    createResourceCenter(resourceData: $resourceData) {
      success
      resource {
        id
        name
        description
        file
        url
        resourceType
        isActive
        order
        created
      }
      errors {
        field
        message
      }
    }
  }
`

// Mutation para actualizar recurso
export const UPDATE_RESOURCE_CENTER = gql`
  mutation updateResourceCenter($id: Int!, $resourceData: resource_center_input!) {
    updateResourceCenter(id: $id, resourceData: $resourceData) {
      success
      resource {
        id
        name
        description
        file
        url
        resourceType
        documentTag {
          id
          tagName
        }
        comments
        isActive
        order
        viewsCount
        updated
      }
      errors {
        field
        message
      }
    }
  }
`

// Mutation string para actualizar recurso (con upload de archivo)
export const UPDATE_RESOURCE_CENTER_STR = `
  mutation updateResourceCenter($id: Int!, $resourceData: resource_center_input!) {
    updateResourceCenter(id: $id, resourceData: $resourceData) {
      success
      resource {
        id
        name
        description
        file
        url
        resourceType
        documentTag {
          id
          tagName
        }
        comments
        isActive
        order
        viewsCount
        updated
      }
      errors {
        field
        message
      }
    }
  }
`

// Mutation para eliminar recurso
export const DELETE_RESOURCE_CENTER = gql`
  mutation deleteResourceCenter($id: Int!) {
    deleteResourceCenter(id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`

// Mutation para incrementar contador de vistas
export const INCREMENT_RESOURCE_VIEWS = gql`
  mutation incrementResourceViews($id: Int!) {
    incrementResourceViews(id: $id) {
      success
      viewsCount
      errors {
        field
        message
      }
    }
  }
`
